import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExtratoSaldoCliente } from 'src/app/admihair/api/dto/extrato-saldo-cliente';
import { ComandaService } from 'src/app/admihair/service/comanda.service';
import { Table } from 'primeng/table';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { RelatorioClienteService } from 'src/app/admihair/service/relatorio-cliente.service';
import { GerenciarDownloadArquivo } from 'src/app/admihair/api/dto/gerenciar-download-arquivo';
import { GerenciarDownloadArquivoService } from 'src/app/admihair/service/gerenciar-download-arquivo.service';
import { UrlServidor } from 'src/app/admihair/util/url-servidor';
import { environment } from 'src/environments/environment';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { TransferenciaCreditoCliente } from 'src/app/admihair/api/dto/transferencia-credito-cliente';
import { TrasnferenciaCreditoClienteService } from 'src/app/admihair/service/transferencia-credito-cliente.service';
import { InputNumber } from 'primeng/inputnumber';
import { InputMask } from 'primeng/inputmask';
import { ExtratoContaCliente } from 'src/app/admihair/api/dto/extrato-conta-cliente';
import { ContaClienteService } from 'src/app/admihair/service/conta-cliente.service';

@Component({
  selector: 'app-central-cliente-conta-detalhar',
  templateUrl: './central-cliente-conta-detalhar.component.html',
  styleUrls: ['./central-cliente-conta-detalhar.component.scss']
})
export class CentralClienteContaDetalharComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  @ViewChild('cpfCliente') inputCpf!: InputMask;
  extratoCliente?: ExtratoSaldoCliente;
  clienteSelecionado?: Cliente;
  contatoCliente?: ContatoCliente;
  lancamentos: ExtratoContaCliente[] = [];
  loading: boolean = false;
  filtroDataInicio?: Date;
  saldoAtual: number = 0;
  loadingRelatorio: boolean = false;
  loadingRelatorioWhatsApp: boolean = false;

  exibirDialogTransferencia: boolean = false;
  loadingDialogTransferencia: boolean = false;
  loadingTransferir: boolean = false;
  loadingBuscarCliente: boolean = false;
  cpfClienteDigitado: string = '';
  clienteParaTransferir?: Cliente;
  valorTransferencia: number = 0;


  constructor(private comandaService: ComandaService,
    private clienteService: ClienteService,
    private contaClienteService: ContaClienteService,
    private transferenciaCreditoClienteService: TrasnferenciaCreditoClienteService,
    private gerenciarDownloadArquivoService: GerenciarDownloadArquivoService,
    private contatoClienteService: ContatoClienteService,
    private relatorioClienteService: RelatorioClienteService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.carregarCliente();
  }

  carregarCliente() {
    this.clienteService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: Cliente) => {
        this.clienteSelecionado = data;
        this.saldoAtual = this.clienteSelecionado.saldoConta ?? 0;
        this.obterContatoCliente();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  obterContatoCliente() {
    this.contatoClienteService.listarPorClienteId(this.clienteSelecionado?.id).subscribe({
      next: (data: ContatoCliente[]) => {
        this.contatoCliente = data.find(contato => contato.principal);
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }



  carregarExtrato() {
    this.loading = true;
    this.contaClienteService.obterExtrato(this.idParametroUrl, this.filtroDataInicio).subscribe({
      next: (data: ExtratoSaldoCliente) => {
        this.extratoCliente = data;
        if (data.lancamentos) {
          this.lancamentos = data.lancamentos;
        }
        this.loading = false;

      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  obterRelatorioPdfExtratoContaAws() {
    this.loadingRelatorio = true;
    this.relatorioClienteService.obterRelatorioPdfExtratoContaAws(this.idParametroUrl, this.getEmpresa().id, this.filtroDataInicio).subscribe({
      next: (data) => {
        window.open(data.url, '_blank');
        this.loadingRelatorio = false;
      },
      error: (err: any) => {
        this.loadingRelatorio = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  enviarMensagemWhatsAppAws() {
    this.loadingRelatorioWhatsApp = true;

    this.relatorioClienteService.obterRelatorioPdfExtratoContaAws(this.idParametroUrl, this.getEmpresa().id, this.filtroDataInicio).subscribe({
      next: (data) => {
        const conteudoMensagem = `Clique no link para baixar o relatorio: ${data.url}`
        const mensagemCodificada = encodeURIComponent(conteudoMensagem);
        const numeroLimpo = this.contatoCliente?.numero ?? '';
        const url = `https://api.whatsapp.com/send?l=pt_br&phone=+55${numeroLimpo}` +
          `&text=${mensagemCodificada}`;
        window.open(url, '_blank');
        this.loadingRelatorioWhatsApp = false;

      },
      error: (err: any) => {
        this.loadingRelatorioWhatsApp = false;
        this.exibirMensagemErro(err);
      }
    })

  }


  abrirJanelaResumo(item: ExtratoContaCliente) {
    const width = window.innerWidth * 0.4;
    const height = window.innerHeight * 0.4;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    
    const url = `${window.location.origin}/#/janela-empresa/${item.urlRecurso}/${item.transacao}`;

    const newWindow = window.open(
      url,
      '_blank',
      `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
    );

    newWindow?.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        newWindow.close();
      }
    });
    newWindow?.addEventListener('load', () => {
      newWindow.document.body.style.overflowX = 'hidden';
    });
  }

  enviarRelatorioWhatsApp() {

    const dto: GerenciarDownloadArquivo = {
      nomeArquivo: 'relatorio_extrato_cliente_' + this.clienteSelecionado?.apelido,
      tipoRelatorioDownload: 'EXTRATO_CLIENTE',
      endpoint: UrlServidor.URL_BASE +
        `relatorios/clientes/${this.clienteSelecionado?.id}/empresa/${this.getEmpresa().id}` +
        `/extrato/data-inicial/${this.filtroDataInicio?.toISOString()}`
    }

    this.gerenciarDownloadArquivoService.salvar(dto).subscribe({
      next: (data: GerenciarDownloadArquivo) => {
        this.enviarMensagemWhatsApp(data.id)

      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })


  }

  enviarMensagemWhatsApp(idArquivo?: string) {
    const conteudoMensagem = `${environment.baseUrl}/#/download-arquivos/${idArquivo}`
    const mensagemCodificada = encodeURIComponent(conteudoMensagem);
    const numeroLimpo = '89981169873';
    const url = `https://api.whatsapp.com/send?l=pt_br&phone=+55${numeroLimpo}` +
      `&text=${mensagemCodificada}`;
    window.open(url, '_blank');
  }

  limparDadosDialogTransferencia() {
    this.clienteParaTransferir = undefined;
    this.valorTransferencia = 0;
    this.cpfClienteDigitado = '';
  }

  abrirDialogTransferir() {
    this.exibirDialogTransferencia = true;
  }

  focarInputValor() {
    setTimeout(() => this.inputCpf.inputViewChild.nativeElement.focus(), 50)
  }

  transferir() {
    this.loadingTransferir = true;
    const transferencia: TransferenciaCreditoCliente = {
      idOrigem: this.clienteSelecionado?.id,
      idDestino: this.clienteParaTransferir?.id,
      tipo: 'TRANSFERENCIA',
      valorTransferido: this.valorTransferencia
    };

    this.transferenciaCreditoClienteService.transferir(transferencia).subscribe({
      next: (data: TransferenciaCreditoCliente) => {
        this.loadingTransferir = false;
        this.exibirDialogTransferencia = false;
        this.limparDadosDialogTransferencia();
        this.exibirMensagemSucesso();
        this.carregarCliente();
        if(this.filtroDataInicio) {
          this.carregarExtrato();
        }
      },
      error: (err: any) => {
        this.loadingTransferir = false;
        this.exibirMensagemErroDialog(err);
      }
    });

  }

  buscarCliente() {
    if (this.cpfClienteDigitado) {
      this.fecharMensagemErroDialog();
      this.loadingBuscarCliente = true;
      this.clienteService.buscarClientePorEmpresaECpf(
        this.getEmpresa().id,
        this.cpfClienteDigitado
      ).subscribe({
        next: (data: Cliente) => {
          this.clienteParaTransferir = data;
          this.loadingBuscarCliente = false;
        },
        error: (err: any) => {
          this.loadingBuscarCliente = false;
          this.exibirMensagemErroDialog(err);

        }
      });
    }
  }

}
